<!-- ===== Header ===== -->
<div class="card shadow-sm border-0 mb-3">
  <div class="card-body py-3">
    <h4 class="card-title mb-0 fw-semibold">
      {{ 'MENU.DASHBOARD.fatwa' | translate }}
    </h4>
  </div>

<!-- ===== Form Card ===== -->
<div class="card shadow-sm border-0">
  <div class="card-body">

    <form (ngSubmit)="onSubmit()" enctype="multipart/form-data">

      <div class="row justify-content-center">
        <div class="col-lg-8">

<div class="mb-3">
  <label class="form-label fw-medium">
    {{ lang === 'ar' ? 'تصنيف الفتوى' : 'Fatwa Category' }}
  </label>

  <select
    class="form-control"
    [(ngModel)]="formData.fatwa_category_id"
    name="fatwa_category_id">

    <option value="">
      {{ lang === 'ar' ? 'اختر التصنيف' : 'Select Category' }}
    </option>

    <option *ngFor="let cat of categories" [value]="cat.id">
      {{ cat.name }}
    </option>

  </select>

  <small class="text-danger" *ngIf="errors?.fatwa_category_id">
    {{ errors.fatwa_category_id[0] }}
  </small>
</div>

<!-- Question -->
<div class="mb-3">
  <label class="form-label fw-medium">
    {{ lang === 'ar' ? 'السؤال' : 'Question' }}
  </label>

  <textarea
    class="form-control"
    rows="3"
    placeholder="{{ lang === 'ar' ? 'السؤال' : 'Question' }}"
    [(ngModel)]="formData.question"
    name="question"
  ></textarea>

  <small class="text-danger" *ngIf="errors?.question">
    {{ errors.question[0] }}
  </small>
</div>

<div class="mb-3">
  <label class="form-label fw-medium">
    {{ lang === 'ar' ? 'الإجابة' : 'Answer' }}
  </label>

  <textarea
    class="form-control"
    rows="4"
    [(ngModel)]="formData.answer"
    name="answer"
    placeholder="{{ lang === 'ar' ? 'اكتب الإجابة هنا' : 'Write the answer here' }}">
  </textarea>

  <small class="text-danger" *ngIf="errors?.answer">
    {{ errors.answer[0] }}
  </small>
</div>
          <!-- Submit -->
          <div class="d-flex justify-content-end">
            <button type="submit" class="btn btn-primary px-4">
              {{ 'MENU.DASHBOARD.Add' | translate }}
            </button>
          </div>

        </div>
      </div>

    </form>

  </div></div>

</div>
